$(document).ready(function() {
    let isAnimating = false;

    function switchTab(nextIdx) {
        if (isAnimating) return;

        const tablinks = $(".tablink");
        const tabcontents = $(".tabcontent");
        let openedIdx = 0;

        for (let i = 0; i < tablinks.length; i++) {
            if ($(tablinks[i]).hasClass("open")) {
                openedIdx = i;
                break;
            }
        }

        if (openedIdx === nextIdx) return;

        isAnimating = true;
        const direction = nextIdx > openedIdx ? "slide-from-right" : "slide-from-left";

        $(tabcontents[openedIdx]).removeClass("open slide-from-right slide-from-left");
        $(tablinks[openedIdx]).removeClass("open");

        const $nextContent = $(tabcontents[nextIdx]);
        $nextContent.removeClass("slide-from-right slide-from-left");
        $nextContent.addClass("open " + direction);
        $(tablinks[nextIdx]).addClass("open");

        $nextContent.one("animationend", function() {
            isAnimating = false;
        });
        setTimeout(function() { isAnimating = false; }, 400);

        const swiperEl = $("#advisoryBlock .swiper")[0];
        if (swiperEl && swiperEl.swiper) {
            swiperEl.swiper.slideTo(nextIdx);
        }
    }

    function navigate(forward) {
        const tablinks = $(".tablink");
        let openedIdx = 0;

        for (let i = 0; i < tablinks.length; i++) {
            if ($(tablinks[i]).hasClass("open")) {
                openedIdx = i;
                break;
            }
        }

        const nextIdx = forward
            ? (openedIdx === tablinks.length - 1 ? 0 : openedIdx + 1)
            : (openedIdx === 0 ? tablinks.length - 1 : openedIdx - 1);

        switchTab(nextIdx);
    }

    $(".slider-reviews-prev").click(function() {
        navigate(false);
    });
    $(".slider-reviews-next").click(function() {
        navigate(true);
    });

    $(".tablink a.nav-link").click(function(e) {
        e.preventDefault();
        const tablinks = $(".tablink");
        const clickedIdx = tablinks.index($(this).closest(".tablink"));
        switchTab(clickedIdx);
    });
});